export default __webpack_public_path__ + "static/media/profile.e4c9f14c.png";